<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-head1">CONTENTS</h1>
<p class="toc"><a href="#/Foreword"><b>Foreword</b></a></p>
<p class="toc"><a href="#/Welcome"><b>Welcome</b></a></p>
<p class="toc"><a href="#/Tools">Tools and Materials</a></p>
<p class="toc"><a href="#/Stitches">Stitches</a></p>
<p class="toc1"><a href="#/Part1"><b>Projects</b></a></p>
<p class="toc"><a href="#/Chapter1">Amelia Earhart</a></p>
<p class="toc"><span href="#/Chapter2" title="Link target outside of Sample">Queen Elizabeth II</span></p>
<p class="toc"><span href="#/Chapter3" title="Link target outside of Sample">Jane Goodall</span></p>
<p class="toc"><span href="#/Chapter4" title="Link target outside of Sample">Audrey Hepburn</span></p>
<p class="toc"><span href="#/Chapter5" title="Link target outside of Sample">Billie Holiday</span></p>
<p class="toc"><span href="#/Chapter6" title="Link target outside of Sample">Cleopatra</span></p>
<p class="toc"><span href="#/Chapter7" title="Link target outside of Sample">Emmeline Pankhurst</span></p>
<p class="toc"><span href="#/Chapter8" title="Link target outside of Sample">Florence Nightingale</span></p>
<p class="toc"><span href="#/Chapter9" title="Link target outside of Sample">Greta Thunberg</span></p>
<p class="toc"><span href="#/Chapter10" title="Link target outside of Sample">Jane Austen</span></p>
<p class="toc"><span href="#/Chapter11" title="Link target outside of Sample">Malala Yousafzai</span></p>
<p class="toc"><span href="#/Chapter12" title="Link target outside of Sample">Marie Curie</span></p>
<p class="toc"><span href="#/Chapter13" title="Link target outside of Sample">Rosa Parks</span></p>
<p class="toc"><span href="#/Chapter14" title="Link target outside of Sample">Ruth Bader Ginsburg</span></p>
<p class="toc"><span href="#/Chapter15" title="Link target outside of Sample">Serena Williams</span></p>
<p class="toc1"><span href="#/Part2" title="Link target outside of Sample"><b>Techniques and Tutorials</b></span></p>
<p class="toc"><span href="#/Techniques" title="Link target outside of Sample">Techniques</span></p>
<p class="toc"><span href="#/Tutorials" title="Link target outside of Sample">Tutorials</span></p>
<p class="toc1"><span href="#/Author" title="Link target outside of Sample"><b>About the Author</b></span></p>
<p class="toc"><span href="#/Acknowledgements" title="Link target outside of Sample"><b>Acknowledgements</b></span></p>
<p class="toc"><span href="#/Wonder" title="Link target outside of Sample"><b>The Wonder Foundation</b></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?530a369e